export default "__VITE_ASSET__Drp3S2oR__"